
import Vue from 'vue'
import dayjs from 'dayjs'

import {
  JcdcDataTable,
  JcdcHeadline,
  JcdcLabeledText,
  JcdcLoadingPage,
  JcdcTabs,
} from '@/components/jcdc/index'

export default Vue.extend({
  name: 'DistanceLearning',
  components: {
    JcdcDataTable,
    JcdcTabs,
    JcdcHeadline,
    JcdcLabeledText,
    JcdcLoadingPage,
  },
  data() {
    return {
      // TABLE
      tableHeader: [
        {
          text: 'Distance Learning Activities',
          value: 'distanceLearningActivities',
        },
        { text: 'Scheduled Hours', value: 'scheduledHours' },
        { text: 'Actual Hours', value: 'actualHours' },
        { text: 'Comments', value: 'notes' },
      ],
      tableData: [],
      totalHours: {},
      thisMonday: this.$store.state.thisMonday,
      thisWeek: this.$store.state.distanceLearning.thisWeek,
      lastWeek: this.$store.state.distanceLearning.lastWeek,
      nextWeek: this.$store.state.distanceLearning.nextWeek,
      lastMonday: this.$store.getters.distanceLearning.lastMonday,
      nextMonday: this.$store.getters.distanceLearning.nextMonday,
    }
  },
  computed: {
    weekList(): Array<{
      text: string
      dateRange: string
      value: string
    }> {
      // Used to create the tab titles and headers - MN
      return [
        {
          text: 'Last Week',
          dateRange: this.formatDateRange(this.lastMonday),
          value: this.lastMonday,
        },
        {
          text: 'This Week',
          dateRange: this.formatDateRange(this.thisMonday),
          value: this.thisMonday,
        },
        {
          text: 'Next Week',
          dateRange: this.formatDateRange(this.nextMonday),
          value: this.nextMonday,
        },
      ]
    },
  },
  created() {
    this.getTableData(this.thisMonday)
  },
  methods: {
    getTableData(date) {
      switch (date) {
        case this.nextMonday:
          this.setTableData(this.nextWeek)
          break
        case this.lastMonday:
          this.setTableData(this.lastWeek)
          break
        default:
          this.setTableData(this.thisWeek)
      }
    },
    setTableData(array) {
      this.tableData = array
      // Calculate Totals
      if (array.length > 0) {
        const totalScheduled = array
            .map((a) => a.scheduledHours)
            .reduce(function (a, b) {
              return a + b
            }),
          totalActual = array
            .map((a) => a.actualHours)
            .reduce(function (a, b) {
              return a + b
            })
        this.totalHours = {
          Hours: {
            Scheduled: totalScheduled,
            Actual: totalActual,
          },
        }
      }
    },
    formatDateRange(monday): string {
      const startDate = dayjs(monday).format('MMM D'),
        endDate = dayjs(monday).add(6, 'days') // Sunday -MN
      let endDateFormat
      //  Check if dates are in the same month. Add month to string if different. -MN
      if (dayjs(startDate).month() == dayjs(endDate).month()) {
        endDateFormat = 'D'
      } else {
        endDateFormat = 'MMM D'
      }
      // Return formatted range -MN
      return `${startDate}–${endDate.format(endDateFormat)}`
    },
  },
})
